// LOCAL.CONFIG.JS - Local App configuration file.
module.exports = 
{
    baseApiGatewayUrl: 'https://localhost:3001'
};

